import { Button } from '@cokitchen/cokitchen-components';
import React, { FC, useState } from 'react';
import LocalModal from 'components/base/local-modal';
import { apiService } from 'services/base.service';
import LocalTextArea from 'components/base/local-text-area';
import { handleApiError } from 'utils/functions';

type ReportRiderModalProps = {
  show: boolean;
  onClose: () => void;
};

const reasons = [
  'Rider delivered orders late, causing delays',
  'Rider delivered incorrect items or missed parts of the order',
  'Experienced rude behaviour from the rider during deliveries',
  'Rider delivered damaged or spilled items',
  'Rider failed to comply with my order notes and procedures',
  'Rider tampered with my order (suspected theft or fraud)'
];
const ReportRiderModal: FC<ReportRiderModalProps> = ({ show, onClose }) => {
  const handleClose = () => {
    onClose();
  };

  const [report, setReport] = useState('');
  const [otherReason, setOtherReason] = useState('');
  const [loading, setLoading] = useState(false);
  const handleSubmit = async () => {
    const data = {
      order_id: '',
      report_rider_note: report || otherReason
    };
    try {
      setLoading(true);
      const res = await apiService.post('{{order-api}}/order/rider/report', { data });
      if (res) {
        setReport('');
        onClose();
      }
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <LocalModal
      isOpen={show}
      onRequestClose={handleClose}
      title='Report rider'
      contentClassName=' sm:!max-w-[400px]'>
      <div>
        <div className='text-gray-3 text-sm ml-9 mb-4  whitespace-nowrap'>
          Kindly select your reason for reporting
        </div>
        <ul className='flex flex-col gap-3'>
          {reasons.map((reason, index) => (
            <li
              key={index}
              className='flex items-center justify-between gap-20 py-3 cursor-pointer select-none'
              onClick={() => {
                setReport(reason);
                setOtherReason('');
              }}>
              <p>{reason}</p>
              <span
                className={`shrink-0 w-[10px] h-[10px] rounded-full ${
                  report === reason
                    ? 'outline outline-2 outline-offset-2 bg-[#F73B58] outline-[#FA8596]'
                    : 'outline outline-2 outline-offset-2 outline-[#D8D9DA]'
                }`}
              />
            </li>
          ))}
        </ul>

        <div>
          <div className='text-sm font-medium flex gap-1 mt-5 mb-2'>
            <p className='text-[#2E3031]'>Other reasons, leave a comment</p>
          </div>
          <LocalTextArea
            placeholder='Got any complaints, remarks...'
            className='text-sm bg-[#FAFAFA] border-x-0 border-t-0 rounded-none h-[130px]'
            value={otherReason}
            onChange={(e) => {
              setOtherReason(e.target.value);
              setReport('');
            }}
          />
        </div>
      </div>
      <div className='mt-5 flex justify-end'>
        <Button
          disabled={!report && !otherReason}
          color='primary'
          variant='block'
          className='w-[139px] h-[41px]'
          loading={loading}
          onClick={handleSubmit}>
          Confirm
        </Button>
      </div>
    </LocalModal>
  );
};

export default ReportRiderModal;
